<template>
  <v-card>
    <employee-history-instructions-tables
      v-if="employee"
      :instructionsHistory="employee.instructionsHistory"
    />
    <employee-history-mentorship-table
      v-if="employee && employee.mentorshipHistory"
      :mentorshipHistory="employee.mentorshipHistory"
    />
    <employee-history-trainings-table
      v-if="
        employee &&
          employee.extTrainingEmployee &&
          employee.extTrainingEmployee.length > 0
      "
      :extTrainingEmployee="employee.extTrainingEmployee"
    />
    <employee-history-health-check-results-table
      v-if="
        employee &&
          employee.healthCheckResults &&
          employee.healthCheckResults.length > 0
      "
      :healthCheckResults="employee.healthCheckResults"
    />
  </v-card>
</template>

<script>
import EmployeeHistoryQuery from "@/graphql/queries/employee/EmployeeHistory.gql";

import EmployeeHistoryInstructionsTables from "@/components/EmployeeHistory/InstructionsTables";
import EmployeeHistoryMentorshipTable from "@/components/EmployeeHistory/MentorshipTable";
import EmployeeHistoryTrainingsTable from "@/components/EmployeeHistory/TrainingsTable";
import EmployeeHistoryHealthCheckResultsTable from "@/components/EmployeeHistory/HealthCheckResultsTable";

export default {
  props: {
    id: {
      type: [Number, String],
      validator: function(value) {
        if (typeof value === "number") {
          return true;
        } else if (typeof value === "string") {
          return !isNaN(Number(value));
        }
        return false;
      },
      required: true,
    },
  },
  components: {
    EmployeeHistoryInstructionsTables,
    EmployeeHistoryMentorshipTable,
    EmployeeHistoryTrainingsTable,
    EmployeeHistoryHealthCheckResultsTable,
  },

  apollo: {
    employee: {
      query: EmployeeHistoryQuery,
      variables() {
        return {
          id: this.id,
        };
      },
    },
  },
};
</script>
